import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';

export interface Sponsor {
    id: string;
    name: string;
    image: string;
    url: string;
    level: 'gold' | 'silver' | 'bronze';
}

export const useSponsors = () => {
    return useQuery<Sponsor[]>({
        queryKey: ['sponsors'],
        queryFn: async () => {
            const { data: sponsorsList } = await api.get('/sponsors');
            return sponsorsList;
        },
    });
};

export const useSaveSponsor = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (sponsor: Partial<Sponsor>) => {
            if (sponsor.id) {
                return api.put(`/admin/sponsors`, sponsor);
            }
            return api.post(`/admin/sponsors`, sponsor);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['sponsors'] });
        },
    });
};

export const useDeleteSponsor = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id: string) => {
            return api.delete(`/admin/sponsors`, { params: { id } });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['sponsors'] });
        },
    });
};
